"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { isPrivacyPolicyPath } from "@/lib/privacy/isPrivacyPolicyPath";
import { trackPrivacyPolicyPageExit } from "@/lib/privacy/privacyPolicyTracking";

/**
 * Fires `exited_privacy_policy_page` when the visitor leaves a Discovery
 * privacy-policy page. In-app navigations use the pathname change. Full
 * unloads (new tab close, external navigation) use `pagehide`. Mount this
 * from the privacy notice so only the announcement cohort is counted.
 */
export function TrackPrivacyPolicyPageExit() {
  const $ = _c(3);
  const pathname = usePathname();
  const privacyPageUrlRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      const nextUrl = isPrivacyPolicyPath(pathname) ? window.location.href : null;
      const previousUrl = privacyPageUrlRef.current;
      if (previousUrl && previousUrl !== nextUrl) {
        trackPrivacyPolicyPageExit(previousUrl);
      }
      privacyPageUrlRef.current = nextUrl;
      if (!nextUrl) {
        return;
      }
      const onPageHide = () => {
        trackPrivacyPolicyPageExit(nextUrl);
      };
      window.addEventListener("pagehide", onPageHide);
      return () => window.removeEventListener("pagehide", onPageHide);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}